import React, { useMemo, useRef } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'
import type { HolidayChartItem } from '../../graphql/types/admin_dashboard'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

export const HolidayGraph = ({
  holidayChart,
}: {
  holidayChart: HolidayChartItem[]
}) => {
  const chartRef = useRef(null)

  const datasets = useMemo(
    () => [
      {
        label: 'Genommener Urlaub',
        data: holidayChart.map((u) => u.holiday_taken),
        backgroundColor: '#FD5C1C',
      },
      {
        label: 'Resturlaub',
        data: holidayChart.map((u) => u.holiday_open),
        backgroundColor: '#2E8F43',
      },
    ],
    [holidayChart],
  )

  const data = {
    labels: holidayChart.map((u) => u.name),
    datasets,
  }

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: 'Urlaub pro Mitarbeiter',
      },
      legend: {
        position: 'top' as const,
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          autoSkip: false,
        },
      },
      y: {
        stacked: true,
        title: {
          display: true,
          text: 'Tage',
        },
      },
    },
  }

  return (
    <div className="flex flex-col py-3 pr-3">
      <Bar ref={chartRef} options={options} data={data} height={80} />
    </div>
  )
}